module.exports = __webpack_public_path__ + "img/artist.bc188a9e.jpg";